import { ErpOrderDiscountedPrice } from '@ca/common'

type DiscountLikeResponse = {
  orders?: ErpOrderDiscountedPrice[]
}

const hasOrders = (value: unknown): value is DiscountLikeResponse => {
  if (!value || typeof value !== 'object') {
    return false
  }
  return Array.isArray((value as DiscountLikeResponse).orders)
}

export const extractDiscountOrders = (
  value: unknown
): ErpOrderDiscountedPrice[] | undefined => {
  if (hasOrders(value)) {
    return value.orders
  }
  if (Array.isArray(value)) {
    return value.flatMap((item) => extractDiscountOrders(item) || [])
  }
  return undefined
}
